import { IntegrationIconProps } from './types';

const Gmail = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || '32'}
    height={dimension ? (dimension * 33) / 32 : '33'}
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1334_1180)">
      <path
        d="M2 11.9556C2 8.47078 2 6.7284 2.67818 5.39739C3.27473 4.22661 4.22661 3.27473 5.39739 2.67818C6.7284 2 8.47078 2 11.9556 2H20.0444C23.5292 2 25.2716 2 26.6026 2.67818C27.7734 3.27473 28.7253 4.22661 29.3218 5.39739C30 6.7284 30 8.47078 30 11.9556V20.0444C30 23.5292 30 25.2716 29.3218 26.6026C28.7253 27.7734 27.7734 28.7253 26.6026 29.3218C25.2716 30 23.5292 30 20.0444 30H11.9556C8.47078 30 6.7284 30 5.39739 29.3218C4.22661 28.7253 3.27473 27.7734 2.67818 26.6026C2 25.2716 2 23.5292 2 20.0444V11.9556Z"
        fill="white"
      />
      <path
        d="M22.0506 8.52295L16.0634 13.1954L9.93945 8.52295V8.52421L9.94685 8.53053V15.0732L15.9944 19.8466L22.0506 15.2575V8.52295Z"
        fill="#EA4335"
      />
      <path
        d="M23.6231 7.38639L22.0508 8.52292V15.2575L26.9983 11.459V9.17074C26.9983 9.17074 26.3978 5.90258 23.6231 7.38639Z"
        fill="#FBBC05"
      />
      <path
        d="M22.0508 15.2577V23.9926H25.8428C25.8428 23.9926 26.9219 23.8814 26.9995 22.6514V11.4591L22.0508 15.2577Z"
        fill="#34A853"
      />
      <path
        d="M9.94713 23.9999V15.0731L9.93945 15.0668L9.94713 23.9999Z"
        fill="#C5221F"
      />
      <path
        d="M9.94014 8.52429L8.37646 7.39407C5.60179 5.91026 5 9.17716 5 9.17716V11.4654L9.94014 15.0669V8.52429Z"
        fill="#C5221F"
      />
      <path
        d="M9.93945 8.52417V15.0668L9.94713 15.0731V8.53048L9.93945 8.52417Z"
        fill="#C5221F"
      />
      <path
        d="M5 11.4666V22.6589C5.07646 23.8901 6.15673 24 6.15673 24H9.94877L9.94014 15.0668L5 11.4666Z"
        fill="#4285F4"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1334_1180"
        x="-2"
        y="-1"
        width="36"
        height="36"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1334_1180"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1334_1180"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default Gmail;
